import { apiRequest } from "../client";
import type {
  ExecutiveSummary,
  MasterAnalysis,
  Analysis,
  NewsFlowResponse,
  ChatMessage,
  ChatRequest,
} from "./types";

export async function getAnalyses(): Promise<Analysis[]> {
  return apiRequest({
    method: "GET",
    url: "/scenario-tracker/analyses",
  });
}

export async function getExecutiveSummary(
  analysisId: string
): Promise<ExecutiveSummary> {
  return apiRequest({
    method: "GET",
    url: `/scenario-tracker/analyses/${analysisId}/executive-summary`,
  });
}

export async function getMasterAnalysis(
  analysisId: string
): Promise<MasterAnalysis> {
  return apiRequest({
    method: "GET",
    url: `/scenario-tracker/analyses/${analysisId}/master-analysis`,
  });
}

export async function getNewsFlow(
  analysisId: string
): Promise<NewsFlowResponse> {
  return apiRequest({
    method: "GET",
    url: `/scenario-tracker/analyses/${analysisId}/news-flow`,
  });
}

export async function getSummaryTable(analysisId: string) {
  return apiRequest({
    method: "GET",
    url: `/scenario-tracker/analyses/${analysisId}/metric-tables`,
    params: {
      view_type: "summary",
      show_impacts: true,
      years: "2026,2030",
    },
  });
}

export async function getMetricTables(
  analysisId: string,
  params: URLSearchParams
) {
  return apiRequest({
    method: "GET",
    url: `/scenario-tracker/analyses/${analysisId}/metric-tables`,
    params: Object.fromEntries(params),
  });
}

export async function getDetails(
  analysisId: string,
  params: {
    category: string;
    metric: string;
    scenario: string;
  }
) {
  return apiRequest({
    method: "GET",
    url: `/scenario-tracker/analyses/${analysisId}/metric-details`,
    params: {
      category: params.category,
      metric: params.metric,
      scenario: params.scenario,
    },
  });
}

export async function getMetricProjections(
  analysisId: string,
  params: {
    category: string;
    metric: string;
    start_year: number;
    end_year: number;
  }
) {
  return apiRequest({
    method: "GET",
    url: `/scenario-tracker/analyses/${analysisId}/metric-projections`,
    params,
  });
}

export async function sendChatMessage(
  analysisId: string,
  message: string,
  conversationHistory: ChatMessage[] = []
) {
  return apiRequest({
    method: "POST",
    url: `/scenario-tracker/experts/chat`,
    data: {
      question: message,
      analysis_id: analysisId,
      conversation_history: conversationHistory,
    } as ChatRequest,
  });
}
